import { Dashboard as DashboardComponent } from '@/view/dashboard/Dashboard';

export const Dashboard = DashboardComponent;
